import clsx from "clsx";
import React, { FC, useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@pd/pd-ui-kit";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useGetLocationData } from "~/hooks/locationData";
import { uploadFile } from "~/libs/uploadFile";
import {
  useImportCarEPlatformDataLazyQuery,
  useImportCreditDataLazyQuery,
} from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";
import { Field } from "~/shared/ui/Field";

import s from "./UploadForm.less";

interface IProps {
  setCloseModal: () => void;
  report: string;
  // refetch;
}

const ImportSRRUploadFileForm: FC<IProps> = ({ setCloseModal, report }) => {
  const { t } = useTranslation();
  const [uploadFileLoader, setUploadFileLoader] = useState(false);
  const { openModal } = useGetLocationData();
  const { notifySuccess, notifyError } = useNotify();
  const [importCreditData, creditData] = useImportCreditDataLazyQuery({
    onCompleted() {
      // refetch();

      notifySuccess(t("common.data_uploaded_successfully"));
      setCloseModal();
    },
    onError() {
      setCloseModal();
    },
  });

  const [ImportCarEPlatformData, CarEPlatformData] =
    useImportCarEPlatformDataLazyQuery({
      onCompleted() {
        // refetch();

        notifySuccess(t("common.data_uploaded_successfully"));
        setCloseModal();
      },
      onError() {
        setCloseModal();
      },
    });

  const schema = yup.object().shape({});

  const { handleSubmit, control, errors, watch } = useForm({
    resolver: yupResolver(schema),
  });

  const watchFile = watch("file");

  const fallBack = () => {
    notifyError(t("common.data_uploaded_error"));
  };

  const onSubmit = () => {
    // Файл грузится при выборе (onUpload поля), здесь остаётся только импорт.
    const fileId = watchFile?.id;

    if (fileId) {
      if (openModal === "addFileCreditData") {
        importCreditData({
          variables: {
            fileId,
          },
        });
      } else {
        ImportCarEPlatformData({
          variables: {
            fileId,
          },
        });
      }
    }
  };
  const isDisable = !!watchFile;

  return (
    <form className={s.upl_form} onSubmit={handleSubmit(onSubmit)}>
      <ul className={s.list}>
        <li>
          <div className={clsx(s.inputWrapper, s.align_label, s.align_error)}>
            <label>{t("srr.uplouad")}</label>
            <Field
              type="file"
              name="file"
              control={control}
              error={errors["file"]?.message}
              accept={["text/csv", "application/vnd.ms-excel"]}
              loading={uploadFileLoader}
              className={s.fileField}
              onUpload={async (file) => {
                setUploadFileLoader(true);
                try {
                  const uploaded = await uploadFile(file, fallBack);
                  if (uploaded) {
                    notifySuccess(t("common.file_uploaded_successfully"));
                    return {
                      id: uploaded.id,
                      name: uploaded.name,
                      link: uploaded.link,
                      mimeType: uploaded.mimeType,
                    };
                  }
                } finally {
                  setUploadFileLoader(false);
                }
              }}
            />
          </div>
        </li>

        <li
          className={clsx(s.text_drop, {
            // [s.text_drop_file]: !isDisable,
          })}
        />
        <li className={s.with_btn}>
          <Button
            htmlType="submit"
            loading={
              creditData.loading || CarEPlatformData.loading || uploadFileLoader
            }
            disabled={!isDisable}
          >
            {t("ui.uploadBase")}
          </Button>
        </li>
      </ul>
    </form>
  );
};
export default ImportSRRUploadFileForm;
